export const EmbedSettingNames = {
  embedAnkerName: 'uc-embed',
  embedTCFAnkerName: 'uc-embed-tcf',
  embedTitle: 'uc-embedding-title',
  embedType: 'uc-embedding-type',
  iabPurposeTitle: 'uc-embedding-purpose',
  iabVendorsTitle: 'uc-embedding-vendors',
  nonIabPurposeTitle: 'uc-embedding-non-iab-purpose',
  nonIabVendorsTitle: 'uc-embedding-non-iab-vendors',
  useUcStylining: 'uc-styling',
};

const Color = {
  blue: '#0000ff',
  lightGray: '#e2e2e2',
  white: '#fff',
};

export const Classnames = {
  link: 'uc-embed-link',
  subElementBlockList: 'uc-embed-subelement-block-list',
  subElementBlockListElement: 'uc-embed-subelement-block-list-element',
  subElementDescription: 'uc-embed-subelement-description',
  subElementHeadline: 'uc-embed-subelement-headline',
  subElementItemList: 'uc-embed-subelement-item-list',
  viewMoreButton: 'uc-embed-block-list-view-more-button',
};

export const Styles = {
  subElementBlockList: {
    style: 'margin: 0px 0px 0px; padding: 0px 15px',
  },
  subElementBlockListElement: {
    style: `font-size: 12px; list-style: none; border: 1px solid ${Color.lightGray}; border-radius: 5px; padding: 10px; margin-top: 5px`,
  },
  viewMoreButton: {
    style: `border: none; background-color: ${Color.white}; text-align: left; padding: 15px; color: ${Color.blue}`,
  },
  /// End Region --- Collapsable Item Content Information Styles
};
